import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-support-card',
    templateUrl: './support-card.component.html',
    styleUrls: ['./support-card.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatIconModule]
})
export class SupportCardComponent {

}
